import React, {useEffect, useState} from 'react';
import '../ChestPurchaseModal/ChestPurchaseModal.css';
import '../RatingCrystalsRewardModal/RatingCrystalsRewardModal.css';
import './RatingCrystalsInfoModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {RatingCrystalsInfo} from '../../pages/RatingCrystalsPage/RatingCrystalsInfo';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';

const PAGE_ID = 'RatingCrystalsInfoModal';

// Картинка знакомства с механикой — одна и та же независимо от сумм: игрок
// еще ничего не заработал, показывать «богатую» кучу не за что
const INTRO_IMAGE_PATH = '/img/crystals/crystals_300.jpg';

/**
 * Знакомство с механикой «Кристаллы за рейтинг»: объясняет, за что вообще
 * капают кристаллы и что за это списывается рейтинг.
 *
 * Тот же корпус и подсветка, что у модалки начислений
 * (RatingCrystalsRewardModal), а текст — ровно тот же блок, что на странице
 * истории: правила описаны в одном месте (RatingCrystalsInfo) и не могут
 * разойтись между экранами.
 *
 * Показывается один раз на устройстве, по кнопке «Отлично!» ставится флаг —
 * см. ratingCrystalsIntroStorage.
 */
const RatingCrystalsInfoModal = ({onClose}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Как у промо-модалок меню (MenuPromoModal): звук разведки рудника
    // остался только у модалки начисления кристаллов за рейтинг
    MENU_SOUND_MANAGER.playModalRoundEnd();
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  return (
    <div
      className={`chest-purchase-overlay rating-crystals-overlay ${visible ? 'chest-purchase-overlay_visible' : ''}`}
      role={'dialog'}
      aria-modal={'true'}
    >
      <div
        className={`chest-purchase-modal rating-crystals-modal ${visible ? 'chest-purchase-modal_visible' : ''}`}
      >
        <div className={'chest-purchase-content'}>
          <h2 className={'rating-crystals-modal_title text-crystals'}>Кристаллы за рейтинг</h2>

          <div className={'chest-purchase-image-wrapper'}>
            <img className={'chest-purchase-image'} src={INTRO_IMAGE_PATH} alt={'Кристаллы'}/>
          </div>

          <RatingCrystalsInfo className={'rating-crystals-info-modal_info'} withTitle={false}/>

          <div className={'main-menu-buttons chest-purchase-buttons'}>
            <PageButton onClick={handleClose} pageId={PAGE_ID} buttonId={'confirm'}>
              Отлично!
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingCrystalsInfoModal;
